import { useEffect } from 'react';

const RECAPTCHA_ENTERPRISE_SITE_KEY_DEV =
  '6LdHFiMrAAAAAB0Fo7dQcKHWetNiF0WYlkkrpKTX';
const RECAPTCHA_ENTERPRISE_SITE_KEY_PROD =
  '6Ld4PyMrAAAAAHKxgKiqbIG_n0sxfxjs0zkCv36y';

const RECAPTCHA_SITE_KEY =
  process.env.NODE_ENV === 'production'
    ? RECAPTCHA_ENTERPRISE_SITE_KEY_PROD
    : RECAPTCHA_ENTERPRISE_SITE_KEY_DEV;

function initializeRecaptcha() {
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);

  script.onload = () => {
    // console.log('reCAPTCHA Enterprise script loaded');
  };

  script.onerror = () => {
    console.error('Failed to load reCAPTCHA Enterprise script');
  };
}

export async function getRecaptchaToken(action) {
  await new Promise(resolve => window.grecaptcha.enterprise.ready(resolve));

  const token = await window.grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, {
    action,
  });

  console.log('Generated token');
  return token;
}

export default function RecaptchaV3() {
  useEffect(() => {
    initializeRecaptcha();
  }, []);

  return <div className="v3" />;
}
